import React from "react";
import { DateTime } from "luxon";

import { DateTimeInput } from "./dateTimeInput";
import { Props } from "./types";
import styles from "./styles.scss";

function Navigation({ currentView, date: d, editDate, today }: Props) {
  const parsed = DateTime.fromISO(d, { zone: "utc" });
  const baseDt = parsed.isValid
    ? parsed
    : DateTime.now().setZone(DateTime.local().zoneName).toUTC();
  const isMonthly = currentView === "month";

  const prev = () => {
    const target = isMonthly
      ? baseDt.minus({ months: 1 })
      : baseDt.minus({ days: 1 });
    editDate(target.toISO() ?? d);
  };

  const next = () => {
    const target = isMonthly
      ? baseDt.plus({ months: 1 })
      : baseDt.plus({ days: 1 });
    editDate(target.toISO() ?? d);
  };

  return (
    <div className={styles.navigation}>
      <DateTimeInput
        date={d}
        input={(dateTime) => editDate(dateTime)}
        prev={prev}
        next={next}
        today={today}
      />
    </div>
  );
}

export { Navigation };
